import apiService from "./ApiService"
import { createQS } from "./Utils"

class AnexoCruzamentoService {
  async get(idCruzamento) {
    try {
      const qs = createQS({ idCruzamento })
      return await apiService.get(`anexo?${qs}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async getById(id) {
    try {
      return await apiService.get(`anexo/${id}`)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async download(idAnexo) {
    try {
      const res = await apiService.get(`anexo/${idAnexo}/download`)
      if (res.success) {
        return res.data.signedUrl
      } else {
        throw new Error('Erro ao baixar o anexo')
      }
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }


  async create(data) {
    try {
      return await apiService.post(`anexo`, data)
    } catch (ex) {
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }

  async delete(id) {
    try {
      return await apiService.delete(`anexo/${id}`)
    } catch (ex) {
      debugger
      if (ex.response.status === 401) {
        throw new Error('Unauthorized')
      } else {
        throw ex
      }
    }
  }
}

const anexoCruzamentoService = new AnexoCruzamentoService()
export default anexoCruzamentoService